import axios from "../libs/axios.lib";

export async function scheduleTaskAPI(numDays, times) {
    try {

        const response = await axios.post("scheduler/schedule", {
            num_days: numDays,
            times: times,
        });

        return response.data;
    } catch (error) {
        console.error("Error scheduling tasks:", error);
        throw error;
    }
}


export async function getScheduledTimesAPI() {
    try {
        const response = await axios.get("scheduler/times"); // matches Flask route
        console.log("Scheduled times response:", response.data);
        return response.data;
       
    } catch (error) {
        console.error("Error fetching scheduled times:", error);
        throw error;
    }
}
